import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  MatDatepicker,
  MatDatepickerInputEvent
} from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig
} from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import * as moment from 'moment';
import { Moment } from 'moment';
import { combineLatest } from 'rxjs';
import { CommonService, SiteService } from 'src/app/services/index';
import {
  AppUtils,
  Constants,
  Highcharts$,
  Moment$
} from 'src/app/shared/index';
import { Hierarchy, TagParameters } from '../../../../../models';

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD'
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-utility-consumption-charts',
  templateUrl: './utility-consumption-charts.component.html',
  styleUrls: ['./utility-consumption-charts.component.scss']
})
export class UtilityConsumptionChartsComponent
  extends Hierarchy
  implements OnInit
{
  siteId: string;
  cost: string;
  misService: string;
  misServiceTitle: string;
  unit: string;
  displayUpdateTagAlert = true;
  tagParameters: TagParameters;
  formData: FormGroup;
  dateRange: any;
  diffInDays: number;

  alwaysShowCalendars: boolean;
  ranges: any = {
    // 'Today': [Moment$(), Moment$()],
    Yesterday: [Moment$().subtract(1, 'days'), Moment$().subtract(1, 'days')],
    'Last 7 Days': [Moment$().subtract(6, 'days'), Moment$()],
    'Last 30 Days': [Moment$().subtract(29, 'days'), Moment$()],
    'This Month': [Moment$().startOf('month'), Moment$().endOf('month')]
    // 'Last Month': [Moment$().subtract(1, 'month').startOf('month'), Moment$().subtract(1, 'month').endOf('month')]
  };
  utilityConsumptionChart: Chart;
  utilityConsumptionChart2: Chart;
  utilityConsumptionChart3: Chart;
  columnchart: Chart;
  startDateStr: string;
  endDateStr: string;
  dailyDatePickerStr: string;
  startDate = new FormControl(moment());
  endDate = new FormControl(moment());
  dailyDatePicker = new FormControl(moment());
  timeBaseRanges = ['Today', 'Weekly', 'Monthly', 'Yearly'];
  timeBase = 'Daily';
  max = new Date();
  startView = 'month';
  minView = 'day';
  hourWiseDataRequired = false;
  yesterdayString: String;
  isFirstLoaded = true;
  thousandSeparator: string;
  decimalSepartor: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private siteService: SiteService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private commonService: CommonService
  ) {
    super();
    this.yesterdayString = `Yesterday (${Moment$()
      .subtract(2, 'days')
      .format(Constants.MOMENT_DATE_FORMAT.DAY_FORMAT)})`;
    this.alwaysShowCalendars = true;
    this.dateRange = {
      startDate: '2020-03-01T07:01:39.547Z',
      endDate: '2020-03-15T07:01:39.547Z'
    };
    // this.dateRange = { startDate: Moment$().subtract(1, 'days'), endDate: Moment$().subtract(1, 'days') };
    //this.onTimeBaseChange();
    this.tagParameters = new TagParameters();
    this.misService = this.activeRoute.snapshot.queryParamMap.get('misService');
    this.siteId = this.activeRoute.snapshot.queryParamMap.get('siteId');
    this.unit = this.activeRoute.snapshot.queryParamMap.get('unit');
    this.thousandSeparator = AppUtils.getThousandSeparator(
      Constants.LOCALE[localStorage.getItem('siteTimezone')]
    );
    this.decimalSepartor = AppUtils.getDecimalSeparator(
      Constants.LOCALE[localStorage.getItem('siteTimezone')]
    );
  }

  chosenStartDate_YearHandler(
    normalizedYear: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.startDate.value;
    ctrlValue.year(normalizedYear.year());
    this.startDate.setValue(moment(ctrlValue).startOf('year'));
    // this.startDate.setValue(ctrlValue);
    datepicker.close();
  }
  chosenStartDate_MonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.startDate.value;
    ctrlValue.month(normalizedMonth.month());
    this.startDate.setValue(moment(ctrlValue).startOf('month'));
    datepicker.close();
  }
  // This is used for daily statistics graph
  chosenMonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.dailyDatePicker.value;
    ctrlValue.month(normalizedMonth.month());
    this.dailyDatePicker.setValue(ctrlValue);
    datepicker.close();
  }
  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.dailyDatePicker.value;
    ctrlValue.year(normalizedYear.year());
    this.dailyDatePicker.setValue(ctrlValue);
  }
  chosenEndDate_YearHandler(
    normalizedYear: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.endDate.value;
    ctrlValue.year(normalizedYear.year());
    this.endDate.setValue(moment(ctrlValue).startOf('year'));
    datepicker.close();
  }
  chosenEndDate_MonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.endDate.value;
    ctrlValue.month(normalizedMonth.month());
    this.endDate.setValue(moment(ctrlValue).startOf('month'));
    datepicker.close();
  }
  transform(date: FormControl) {
    if (date.valid) {
      return this.datePipe.transform(date.value, 'yyyy-MM-dd');
    } else {
      return '';
    }
  }
  private transformDate = () => {
    // this.startDate = Moment$(this.dateRange.startDate).format(Constants.MOMENT_DATE_FORMAT.DATE_FORMAT);
    // this.endDate = Moment$(this.dateRange.endDate).format(Constants.MOMENT_DATE_FORMAT.DATE_FORMAT);
    this.startDateStr = this.transform(this.startDate);
    this.endDateStr = this.transform(this.endDate);
    this.dailyDatePickerStr = this.transform(this.dailyDatePicker);
  };
  onTimeBaseChange(event?: any) {
    if (!this.commonService.isNullOrUndefined(event)) {
      this.timeBase = event;
    }

    switch (this.timeBase) {
      case 'Yearly': {
        this.startView = 'multi-year';
        this.minView = 'year';
        var lastYear = moment().subtract(2, 'year');
        this.startDate = new FormControl(moment(lastYear).startOf('year'));
        this.hourWiseDataRequired = false;
        break;
      }
      case 'Monthly':
      case 'Quarterly': {
        this.startView = 'year';
        this.minView = 'month';
        this.startDate = new FormControl(moment().startOf('year'));
        this.hourWiseDataRequired = false;
        break;
      }
      case 'Weekly': {
        this.startView = 'month';
        this.minView = 'day';
        this.startDate = new FormControl(moment().startOf('month'));
        this.hourWiseDataRequired = false;
        break;
      }
      default: {
        this.startView = 'month';
        this.minView = 'day';
        this.startDate = new FormControl(moment().startOf('month'));
        //  this.startDate = new FormControl(moment().subtract(2, 'days'));
        this.hourWiseDataRequired = true;
        break;
      }
    }
    this.endDate = new FormControl(moment());
  }

  ngOnInit() {
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );
    urlParams.subscribe((routeParams) => {
      this.siteId = routeParams.siteId;
      this.transformDate();
      this.getKPITrends();
      this.getKPITrends2();
      this.getKPITrends3(false);
    });
  }

  public onChangeDateRange = () => {
    if (
      Moment$(this.dateRange.endDate).diff(
        Moment$(this.dateRange.startDate),
        'days'
      ) > 31
    ) {
      this.commonService.showDialogMessage(
        'Note: Data display limited to 31 days. Please select duration not more than 31 days'
      );
      return;
    }
    if (this.commonService.isLaterThanCurentDate(this.dateRange.endDate)) {
      this.commonService.showDialogMessage(Constants.FUTURE_DATE_NOT_ALLOW);
      return;
    }
    if (
      this.isFirstLoaded === false &&
      this.siteId !== null &&
      this.siteId !== undefined
    ) {
      this.getKPITrends3(true);
    }
  };
  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    // this.events.push(`${type}: ${event.value}`);
    // if ((this.startDate.invalid || this.endDate.invalid) && (this.startDate<= this.endDate)
    //   Moment$(this.dateRange.endDate).diff(
    //     Moment$(this.dateRange.startDate),
    //     'days'
    //   ) > 31
    // ) {
    //   this.commonService.showDialogMessage(
    //     'Note: Data display limited to 31 days. Please select duration not more than 31 days'
    //   );
    //   return;
    // }
    // if (this.commonService.isLaterThanCurentDate(this.dateRange.endDate)) {
    //   this.commonService.showDialogMessage(Constants.FUTURE_DATE_NOT_ALLOW);
    //   return;
    // }

    if (this.startDate.invalid || this.endDate.invalid) {
      return;
    } else {
      if (this.startDate.value > this.endDate.value) {
        return;
      } else {
        this.getKPITrends3(true);
      }
    }
  }

  onBack() {
    this.router.navigate(['site', 'over-view'], {
      queryParams: { siteId: this.siteId, activedTab: 0 }
    });
  }

  private getKPITrends = () => {
    this.onTimeBaseChange('Monthly');
    this.transformDate();
    this.siteService
      .getServiceChartInfo(
        this.siteId,
        this.misService,
        'Monthly',
        this.startDateStr,
        this.endDateStr
      )
      .subscribe((data) => {
        if (data.result) {
          const series = [];
          if (data.unit != '') {
            this.unit = data.unit;
          }
          var unit = ' ' + this.unit;
          if (this.misService == 'Nitrogen Consumption') {
            unit = ' m³/day';
          }
          const categories = [];
          data.result.forEach((v, i) => {
            categories.push(<any>v.xAxis);
            const entries = Object.entries(v.serviceAndConsumption);
            if (entries.length > 0) {
              let xObject: { x: number; y: any } = { x: 0, y: null };
              xObject.x = i;
              let dataPaser = {
                data: [],
                name: '',
                yAxis: 0,
                type: 'column',
                tooltip: {
                  valueSuffix: unit
                }
              };
              for (const [key, value] of entries) {
                dataPaser = {
                  data: [],
                  name: '',
                  yAxis: 0,
                  type: 'column',
                  tooltip: {
                    valueSuffix: unit
                  }
                }; // Reset value
                xObject.y = value;
                dataPaser.name = key;

                const index = series.findIndex((se) => se.name === key);
                if (index === -1) {
                  dataPaser.data.push(xObject);
                  series.push(dataPaser);
                } else {
                  const current = series[index];
                  current.data.push(xObject);
                  series[index] = current;
                }
                xObject = { x: i, y: null }; // Reset value
              }
            } else {
              const xObject: { x: number; y: any } = { x: 0, y: null };
              xObject.x = i;
              const dataPaser = { data: [], name: '' };
              xObject.y = null;
              dataPaser.data.push(xObject);
              series.push(dataPaser);
            }
          });
          let targetPaser = {
            data: [],
            name: 'Budget',
            yAxis: 1,
            type: 'spline',
            tooltip: {
              valueSuffix: ' INR'
            }
          };
          let ConsumptionTargetPaser = {
            data: [],
            name: 'Consumption Target',
            yAxis: 1,
            type: 'spline',
            tooltip: {
              valueSuffix: ' INR'
            }
          };
          // for (var i = 0; i < data.target.budgetTarget.length; i++) {
          //   targetPaser.data.push(data.target.budgetTarget[i]);
          //   ConsumptionTargetPaser.data.push(data.target.consumptionTarget[i]);
          // }
          // series.push(targetPaser);
          // series.push(ConsumptionTargetPaser);

          const tags =
            data.DataTags == null || data.DataTags === undefined
              ? []
              : data.DataTags;

          this.onInitBuildingWiseChart(categories, series, tags, unit);
        }
      });
  };
  private setTagDetails = (paramName: string, tagtxtime: string) => {
    //  this.tagParameters.siteID = this.siteId;
    // this.tagParameters.tagDescription = '';
    //  this.tagParameters.paramName = paramName;
    // this.tagParameters.time = tagtxtime;
  };
  private customRealTimeInfoDataPointClick = (event: any) => {
    const point = event.point; // series.nameconsole.log("point name-->"+point.series.name);
    if (point.series.name !== 'Data Tags') {
      const tagtxtime = point.category;
      const paramName = point.series.name;

      this.setTagDetails(paramName, tagtxtime);
      this.tagParameters.paramName = point.series.name;
      this.tagParameters.time = point.category;
      this.tagParameters.siteID = 'BOSCBang56011252';
      const dialogConfig: MatDialogConfig = {
        width: '70%',
        data: { tagParameters: this.tagParameters }
      };
      // this.dialog.open(misDataTagComponent, dialogConfig);
    }
  };
  private getKPITrends2 = () => {
    this.onTimeBaseChange('Yearly');
    this.transformDate();
    this.siteService
      .getServiceChartInfo(
        this.siteId,
        this.misService,
        'Yearly',
        this.startDateStr,
        this.endDateStr
      )
      .subscribe((data) => {
        if (data.result) {
          for (var i = 0; i < 3; i++) {
            const series = [];
            const seriesresult = [];
            const categories = [];
            if (data.unit != '') {
              this.unit = data.unit;
            }
            var unit = ' ' + this.unit;
            if (this.misService == 'Nitrogen Consumption') {
              unit = ' m³/day';
            }
            data.result.forEach((v, i) => {
              categories.push(<any>v.xAxis);
              const entries = Object.entries(v.serviceAndConsumption);
              if (entries.length > 0) {
                let xObject: { x: number; y: any } = { x: 0, y: null };
                xObject.x = i;
                let dataPaser = {
                  data: [],
                  name: '',
                  yAxis: 0,
                  type: 'column',
                  tooltip: {
                    valueSuffix: '' + unit
                  }
                };

                for (const [key, value] of entries) {
                  dataPaser = {
                    data: [],
                    name: '',
                    yAxis: 0,
                    type: 'column',
                    tooltip: {
                      valueSuffix: '' + unit
                    }
                  }; // Reset value
                  xObject.y = value;
                  dataPaser.name = key;
                  const index = series.findIndex((se) => se.name === key);
                  if (index === -1) {
                    dataPaser.data.push(xObject);
                    series.push(dataPaser);
                  } else {
                    const current = series[index];
                    current.data.push(xObject);
                    series[index] = current;
                  }
                  xObject = { x: i, y: null }; // Reset value
                }
              } else {
                const xObject: { x: number; y: any } = { x: 0, y: null };
                xObject.x = i;
                const dataPaser = { data: [], name: '' };
                xObject.y = null;
                dataPaser.data.push(xObject);

                series.push(dataPaser);
              }
            });
            let targetPaser = {
              data: [],
              name: 'Budget',
              yAxis: 1,
              type: 'spline',
              tooltip: {
                valueSuffix: ' INR'
              }
            };
            let ConsumptionTargetPaser = {
              data: [],
              name: 'Consumption Target',
              yAxis: 1,
              type: 'spline',
              tooltip: {
                valueSuffix: ' INR'
              }
            };
            // for (var i = 0; i < data.target.budgetTarget.length; i++) {
            //   targetPaser.data.push(data.target.budgetTarget[i]);
            //   ConsumptionTargetPaser.data.push(
            //     data.target.consumptionTarget[i]
            //   );
            // }
            // series.push(targetPaser);
            // series.push(ConsumptionTargetPaser);

            this.onInitBuildingWiseChart2(categories, series, unit);
          }
        }
      });
  };

  private getKPITrends3 = (dateBased) => {
    if (!dateBased) {
      this.onTimeBaseChange('Daily');
    }
    this.transformDate();
    this.isFirstLoaded = false;
    var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
    var a = new Date(this.startDateStr);
    var b = new Date(this.endDateStr);
    var diff = Math.abs(a.getTime() - b.getTime());
    var diffDays = Math.ceil(diff / (1000 * 3600 * 24));

    this.siteService
      .getServiceChartInfo(
        this.siteId,
        this.misService,
        'Daily',
        this.startDateStr,
        this.endDateStr
      )
      .subscribe((data) => {
        if (data.result) {
          if (data.unit != '') {
            this.unit = data.unit;
          }
          var unit = ' ' + this.unit;
          if (this.misService == 'Nitrogen Consumption') {
            unit = ' m³/day';
          }
          const tags =
            data.DataTags == null || data.DataTags === undefined
              ? []
              : data.DataTags;
          console.log('tags-->' + tags);
          const series = [];
          const categories = [];
          data.result.forEach((v, i) => {
            categories.push(<any>v.xAxis);
            const entries = Object.entries(v.serviceAndConsumption);
            if (entries.length > 0) {
              let xObject: { x: number; y: any } = { x: 0, y: null };
              xObject.x = i;
              let dataPaser = {
                data: [],
                name: '',
                yAxis: 0,
                type: 'column',
                tooltip: {
                  valueSuffix: '' + unit
                }
              };

              for (const [key, value] of entries) {
                dataPaser = {
                  data: [],
                  name: '',
                  yAxis: 0,
                  type: 'column',
                  tooltip: {
                    valueSuffix: '' + unit
                  }
                }; // Reset value
                xObject.y = value;
                dataPaser.name = key;
                const index = series.findIndex((se) => se.name === key);
                if (index === -1) {
                  dataPaser.data.push(xObject);
                  series.push(dataPaser);
                } else {
                  const current = series[index];
                  current.data.push(xObject);
                  series[index] = current;
                }
                xObject = { x: i, y: null }; // Reset value
              }
            } else {
              const xObject: { x: number; y: any } = { x: 0, y: null };
              xObject.x = i;
              const dataPaser = { data: [], name: '' };
              xObject.y = null;
              dataPaser.data.push(xObject);

              series.push(dataPaser);
            }
          });
          let targetPaser = {
            data: [],
            name: 'Budget',
            yAxis: 1,
            type: 'spline',
            tooltip: {
              valueSuffix: ' INR'
            }
          };
          let ConsumptionTargetPaser = {
            data: [],
            name: 'Consumption Target',
            yAxis: 1,
            type: 'spline',
            tooltip: {
              valueSuffix: ' INR'
            }
          };
          // for (var i = 0; i < data.target.budgetTarget.length; i++) {
          //   targetPaser.data.push(data.target.budgetTarget[i]);
          //   ConsumptionTargetPaser.data.push(data.target.consumptionTarget[i]);
          // }
          // series.push(targetPaser);
          // series.push(ConsumptionTargetPaser);
          this.onInitBuildingWiseChart3(categories, series, tags, unit);
        }
      });
  };
  onInitBuildingWiseChart(categories: any, series: any, tags: any, unit: any) {
    const self = this;
    let xAxis: any;
    xAxis = {
      categories: categories,
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: 'bold'
        }
      }
    };
    const dataTagSeriesOptions = {
      name: 'Data Tags',
      lineWidth: 0,
      data: [],
      yAxis: 'DataTags',
      states: {
        hover: {
          lineWidthPlus: 0
        }
      },
      marker: {
        enabled: true,
        symbol: 'url(./assets/img/data_tag_redflag.png)'
      }
    };

    let timezone = '';
    if (localStorage.getItem('siteTimezone') !== undefined) {
      timezone = localStorage.getItem('siteTimezone');
    }

    Highcharts$.setOptions({
      lang: {
        decimalPoint: self.decimalSepartor,
        thousandsSep: self.thousandSeparator
      }
    });
    const chartOption = {
      chart: {
        type: 'column',
        height: 450
        // width: 820
      },
      credits: {
        enabled: false
      },
      title: {
        text: 'Monthly Statistics',
        style: {
          fontSize: '14px',
          fontWeight: 'bold'
        }
      },

      xAxis: xAxis,

      yAxis: [
        {
          // Primary yAxis
          labels: {
            formatter: function () {
              return new Intl.NumberFormat(Constants.LOCALE[timezone]).format(
                +this.value
              );
            },
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          },
          title: {
            text: 'Consumption' + ' (' + unit + ')',
            style: {
              fontWeight: 'bold',
              fontSize: '14px'
            }
          },
          min: 0
        }
        // {
        //   // 3rd yAxis
        //   labels: {
        //     formatter: function () {
        //       return Highcharts$.numberFormat(this.value, Constants.DECIMAL_FORMAT.DECIMAL_NO);
        //     },
        //     style: {
        //       fontSize: '14px',
        //       fontWeight: 'bold'
        //     }
        //   },
        //   title: {
        //     text: 'Cost (JPY)',
        //     style: {
        //       fontWeight: 'bold',
        //       fontSize: '14px'
        //     }
        //   },
        //   min: 0,
        //   opposite: true
        // }
      ],
      tooltip: {
        formatter: function () {
          return (
            '<b><span style="font-size:10px">' +
            this.point.category +
            '</span></b><br/><span style="color:' +
            this.series.points[this.point.index].color +
            '">\u25CF</span>   ' +
            this.series.name +
            ': <b>' +
            new Intl.NumberFormat(Constants.LOCALE[timezone], {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(+this.y) +
            unit +
            '</b>'
          );
        }
      },
      // tooltip:
      // {
      //   shared: true,
      //   valueSuffix:' kw'
      // },
      // tooltip: {
      //   shared: true
      // },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom'
        // title: {
        //   text: ':: Drag me'
        // },
        // floating: true,
        // draggable: true,
        // backgroundColor: '#FFFFFF'
      },
      plotOptions: {
        series: {
          marker: {
            enabled: false
          },

          turboThreshold: 0,
          threshold: null,
          point: {
            events: {
              click: function (callback) {
                return callback;
              }
            }
          }
        },
        column: {
          stacking: 'normal'
        }
      },
      visible: true,
      series: series
    };
    this.utilityConsumptionChart = new Chart(<any>chartOption);
  }
  onInitBuildingWiseChart2(categories: any, seriesresult: any, unit: any) {
    const self = this;
    let xAxis: any;
    xAxis = {
      categories: categories,
      labels: {
        style: {
          fontWeight: 'bold',
          fontSize: '14px'
        }
      }
    };

    let timezone = '';
    if (localStorage.getItem('siteTimezone') !== undefined) {
      timezone = localStorage.getItem('siteTimezone');
    }

    Highcharts$.setOptions({
      lang: {
        decimalPoint: self.decimalSepartor,
        thousandsSep: self.thousandSeparator
      }
    });
    const chartOption = {
      chart: {
        type: 'column',
        height: 450
        // width: 800
      },
      credits: {
        enabled: false
      },
      title: {
        text: 'Yearly Statistics',
        style: {
          fontSize: '14px',
          fontWeight: 'bold'
        }
      },

      xAxis: xAxis,
      yAxis: [
        {
          // Primary yAxis
          labels: {
            formatter: function () {
              return new Intl.NumberFormat(Constants.LOCALE[timezone]).format(
                +this.value
              );
            },
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          },
          title: {
            text: 'Consumption' + ' (' + unit + ')',
            style: {
              fontWeight: 'bold',
              fontSize: '14px'
            }
          },
          min: 0
        }
        // {
        //   // 3rd yAxis
        //   labels: {
        //     formatter: function () {
        //       return Highcharts$.numberFormat(this.value, Constants.DECIMAL_FORMAT.DECIMAL_NO);
        //     },
        //     style: {
        //       fontSize: '14px',
        //       fontWeight: 'bold'
        //     }
        //   },
        //   title: {
        //     text: 'Cost (JPY)',
        //     style: {
        //       fontWeight: 'bold',
        //       fontSize: '14px'
        //     }
        //   },
        //   min: 0,
        //   opposite: true
        // }
      ],
      tooltip: {
        formatter: function () {
          return (
            '<b><span style="font-size:10px">' +
            this.point.category +
            '</span></b><br/><span style="color:' +
            this.series.points[this.point.index].color +
            '">\u25CF</span>   ' +
            this.series.name +
            ': <b>' +
            new Intl.NumberFormat(Constants.LOCALE[timezone]).format(+this.y) +
            unit +
            '</b>'
          );
        }
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom'
      },
      plotOptions: {
        column: {
          stacking: 'normal'
        },
        series: {
          marker: {
            enabled: false
          }
        }
      },

      series: seriesresult
    };
    this.utilityConsumptionChart2 = new Chart(<any>chartOption);
  }

  onInitBuildingWiseChart3(
    categories: any,
    seriesresult: any,
    tags: any,
    unit: any
  ) {
    const self = this;
    let xAxis: any;
    xAxis = {
      categories: categories,
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: 'bold'
        }
      }
    };
    const dataTagSeriesOptions = {
      name: 'Data Tags',
      lineWidth: 0,
      data: [],
      yAxis: 'DataTags',
      states: {
        hover: {
          lineWidthPlus: 0
        }
      },
      marker: {
        enabled: true,
        symbol: 'url(./assets/img/data_tag_redflag.png)'
      }
    };

    let timezone = '';
    if (localStorage.getItem('siteTimezone') !== undefined) {
      timezone = localStorage.getItem('siteTimezone');
    }

    Highcharts$.setOptions({
      lang: {
        decimalPoint: self.decimalSepartor,
        thousandsSep: self.thousandSeparator
      }
    });
    const chartOption = {
      chart: {
        type: 'column',
        height: 450
        //width: 900
      },
      credits: {
        enabled: false
      },
      title: {
        text: 'Daily Statistics',
        style: {
          fontSize: '14px',
          fontWeight: 'bold'
        }
      },

      xAxis: xAxis,
      yAxis: [
        {
          // Primary yAxis
          labels: {
            formatter: function () {
              return new Intl.NumberFormat(Constants.LOCALE[timezone]).format(
                +this.value
              );
            },
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          },
          title: {
            text: 'Consumption' + ' (' + unit + ')',
            style: {
              fontWeight: 'bold',
              fontSize: '14px'
            }
          },
          min: 0
        },

        // {
        //   // 3rd yAxis
        //   labels: {
        //     formatter: function () {
        //       return Highcharts$.numberFormat(this.value, Constants.DECIMAL_FORMAT.DECIMAL_NO);
        //     },
        //     style: {
        //       fontSize: '14px',
        //       fontWeight: 'bold'
        //     }
        //   },
        //   title: {
        //     text: 'Cost (JPY)',
        //     style: {
        //       fontWeight: 'bold',
        //       fontSize: '14px'
        //     }
        //   },
        //   min: 0,
        //   opposite: true
        // },
        {
          id: 'DataTags',
          title: {
            text: ''
          },
          labels: {
            formatter: function () {
              return '';
            }
          },
          opposite: false
        }
      ],
      tooltip: {
        formatter: function () {
          return (
            '<b><span style="font-size:10px">' +
            this.point.category +
            '</span></b><br/><span style="color:' +
            this.series.points[this.point.index].color +
            '">\u25CF</span>   ' +
            this.series.name +
            ': <b>' +
            new Intl.NumberFormat(Constants.LOCALE[timezone]).format(+this.y) +
            unit +
            '</b>'
          );
        }
      },
      // tooltip: {
      //   shared: true
      // },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom'
      },
      plotOptions: {
        series: {
          marker: {
            enabled: false
          },

          turboThreshold: 0,
          threshold: null,
          point: {
            events: {
              click: function (callback) {
                return callback;
              }
            }
          }
        },
        column: {
          stacking: 'normal'
        }
      },

      series: seriesresult
    };
    // chartOption.plotOptions.series.point.events.click =
    //   this.customRealTimeInfoDataPointClick;
    if (tags.length > 0) {
      console.log('tags available');

      chartOption.series.push(<any>dataTagSeriesOptions);
    } else {
      console.log('data tag -> zero');
    }
    this.utilityConsumptionChart3 = new Chart(<any>chartOption);
  }
}
